module.exports = __webpack_public_path__ + "static/media/red_circle.61025929.svg";